import React,{Suspense } from 'react';
import {Routes, Route} from "react-router-dom";
import { FsCircularProgress, Box } from '@aviatrix/flights';
import NotFound from '../pages/404';

import routing from './routing';

import {InProcess} from '../pages/components';

const AppRoutes = ()=>{
    const routeComponents = routing.map((r:any, key:number) =>{
        return <Route key={key}  {...r} Component={r.component} />   
    });
    
    return(
        <Box className="page">
            <Suspense fallback={<Fallback/>}>
                <Routes>
                    {routeComponents}
                    <Route path="*" element={<NotFound/>} />
                </Routes>
            </Suspense>
        </Box>
    )
}

const Fallback = ()=>{
    return (
        <>
            <Box>
                <InProcess show={true} 
                    size='large'
                    text="Getting ready to launch Aviatrix..." 
                    desc="Do not close this window." 
                    textAlign='left'
                    />
            </Box>
        </> 
    )
}


export default AppRoutes;